<template>
  <div class="main temu-create">
    <div v-if="$route.query.listingStatus == 1" class="update-alert f--c">
      <i class="el-icon-warning"></i>
      <div style="margin: 0 10px;">因平台接口限制，产品属性、产品描述、变种图等信息不能同步，同时不可编辑在线产品</div>
    </div>

    <h1 class="f--c">
      <div class="left bg-green"></div>
      <div>Production Editor</div>
    </h1>
    <!-- <div class="head f--c">
      <div class="f--c"><span class="title">Platform:</span>{{ `TEMU` }}</div>
      <div class="f--c"><span class="title">Store:</span>{{ `Huikaka` }}</div>
    </div> -->
    <div class="head-product f--c">
      <!-- <div class="left">
        <oss-img src="" :width="212" :height="292" />
      </div> -->
      <div class="right">
        <div class="item">
          <div class="title"><span class="star">*</span>店铺 Store</div>
          <el-select v-model="create.storeId" placeholder="Please select" size='mini' style="width:100%" @change="temuGetCategories">
            <el-option
              v-for="item in storeList"
              :key="item.storeId"
              :label="item.storeName"
              :value="item.storeId"
            >
            </el-option>
          </el-select>
        </div>
        <div class="f--c">
          <div class="item" style="margin-right:20px">
            <div class="title"><span class="star">*</span>分类 Category</div>
            <el-cascader
              ref="cascaderCat"
              :options="categoriesList"
              :props="{ expandTrigger: 'hover', value: 'catId', label: 'catName', emitPath: false}"
              clearable
              @change="categorysChange"
              v-model="create.catId"
              :show-all-levels="false"
              size='mini'
              style="width: 100%"
              class="borderTo2">
            </el-cascader>
          </div>
          <div class="item">
            <div class="title"><span class="star"></span>SPU</div>
            <div class="f--c">
              <el-input
                v-model="create.spuCode"
                type="text"
                placeholder="Please input"
                size='mini'
              />
              <el-button size="mini" style="margin-left:8px;" :disabled="!create.spuCode" @click="temuGetLoadSpu">Load SPU Data</el-button>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="title"><span class="star">*</span>产品名称 Product Name</div>
          <el-input
            v-model="create.productName"
            type="text"
            placeholder="Please input"
            maxlength="250"
            show-word-limit
            size='mini'
          />
        </div>
        <div class="f--c">
          <div v-if="create.productWhExtAttrReq && create.productWhExtAttrReq.productOrigin" class="item" style="margin-right:20px">
            <div class="title"><span class="star">*</span>商品产地 Commodity Origin</div>
            <el-select v-model="create.productWhExtAttrReq.productOrigin.countryShortName" placeholder="Please select" size='mini' style="width:100%">
              <el-option
                v-for="item in commodityOrigins"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <div class="title"><span class="star">*</span>语言 Language</div>
            <el-checkbox-group v-model="checkLanguage">
              <el-checkbox v-for="item in Languages" :key="item.name" :label="item.label" :disabled="item.disabled">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div v-if="create.catId" class="content-box">
      <div class="box" v-if="tableAttr.length">
        <div class="title"><span class="star">*</span>成分</div>
        <el-table :data="tableAttr" border style="width: 100%">
          <el-table-column>
            <template slot="header">
              <div class="title" style="margin-bottom: 0;"><span class="star">*</span>材质 Material</div>
            </template>
            <div slot-scope="{row}">
              <el-select v-model="row.vid" placeholder="Please select" size='mini' style="width:100%" @change="changeAttr(row)">
                <el-option
                  v-for="item in row.values"
                  :key="item.vid"
                  :label="item.value"
                  :value="item.vid"
                  :disabled="tableAttr.some(t => t.vid === item.vid)"
                >
                </el-option>
              </el-select>
            </div>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <div class="title" style="margin-bottom: 0;"><span class="star">*</span>成分比例 Component Ratio ("成分比例" 之和必须为100%)</div>
            </template>
            <div slot-scope="{row}">
              <el-input placeholder="Please input" v-model="row.numberInputValue" size='mini' @input="e => handleInput(e, row, 'numberInputValue')" @blur="handleBlur(row, 'numberInputValue', row.numberInputValue, 2)">
                <template slot="append">%</template>
              </el-input>
            </div>
          </el-table-column>
          <el-table-column label="操作 Operate" width="180">
            <el-button slot-scope="{$index}" v-if="tableAttr.length > 1" type="text" @click="tableDelete(tableAttr, $index)">Delete</el-button>
          </el-table-column>
        </el-table>
        <div class="add color-green">
          <el-button icon="el-icon-plus" size='mini' type="text" @click="tableAdd('tableAttr')">Add</el-button>
        </div>
      </div>
      <div v-if="tableAttr.length" class="box">
        <div class="attr-list f-b-c">
          <div class="item" v-for="item in enumAttr" :key="item.pid">
            <div class="title"><span v-if="item.required" class="star">*</span>{{ item.propName }}</div>
            <el-select v-model="item.vid" placeholder="Please select" size='mini' style="width:100%" @change="changeAttr(item)">
              <el-option
                v-for="t in item.values"
                :key="t.vid"
                :label="t.value"
                :value="t.vid"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item"></div>
        </div>
      </div>
      <div class="box">
        <div class="title"><span class="star">*</span>颜色 Color</div>
        <el-table :data="colors" border style="width: 100%">
          <el-table-column width="220">
            <template slot="header">
              <div class="title"><span class="star">*</span>色值 Color Value</div>
            </template>
            <div slot-scope="{row, $index}">
              <el-cascader
                v-model="row.colour_value"
                :options="colorAttr.cascader"
                :show-all-levels="false"
                :props="{ expandTrigger: 'hover', value: 'specId', label: 'specName', emitPath: false}"
                placeholder="Please select"
                @change="e => changeColor(e, row, $index)"
              >
                <div slot-scope="{ data }" class="color-select f--c">
                  <i :style="{backgroundColor: `rgba${data.extendInfo}`}"></i>
                  <span>{{ data.specName }}</span>
                </div>
              </el-cascader>
            </div>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <div class="title"><span class="star">*</span>轮播图 Carousel (5-10张，宽高比例为3:4，宽>1340px，高>1785px，小于2M)</div>
            </template>
            <div class="f" slot-scope="{row}">
              <div class="title" style="flex-shrink: 0;padding-top:20px"><span class="star">*</span>English</div>
              <div class="img-list f--c">
                <div v-for="(item, i) in row.previewImgUrls" :key="i" class="img-item">
                  <el-popover
                    placement="bottom-start"
                    width="260"
                    trigger="hover">
                    <div class="img-sort f--c">
                      <el-radio v-model="item.index" :label="0" border size="mini" @input="e => handleSortImg(e, row, i)">Front view</el-radio>
                      <el-radio v-model="item.index" :label="1" border size="mini" @input="e => handleSortImg(e, row, i)">Rear View</el-radio>
                    </div>
                    <div slot="reference" style="position: relative;">
                      <div class="img-item-head">
                        <span v-if="i===0">Front view</span>
                        <span v-if="i===1">Rear View</span>
                      </div>
                      <oss-img :src="item.src" :width="56" :height="56" />
                    </div>
                  </el-popover>
                  <div class="icon-x f-c-c pointer" @click="tableDelete(row.previewImgUrls, i, 'carousel')">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
                <div v-if="row.previewImgUrls.length < 10" style="padding-top:12px">
                  <el-upload v-if="1" list-type="picture-card" class="upload-demo" action="" :multiple="false" accept="image/*" :before-upload="file => beforeUpload(file, row, 'colors')">
                    <div>上传</div>
                  </el-upload>
                </div>
              </div>
            </div>
          </el-table-column>
          <el-table-column width="180">
            <template slot="header">
              <div class="title">SPU货号</div>
            </template>
            <div slot-scope="{row}">
              <el-input placeholder="Please Input" v-model="row.extCode" maxlength="120" show-word-limit size='mini'></el-input>
            </div>
          </el-table-column>
          <el-table-column label="操作 Operate" width="120">
            <el-button slot-scope="{$index}" v-if="colors.length > 1" type="text" @click="tableDelete(colors, $index)">Delete</el-button>
          </el-table-column>
        </el-table>
        <div class="add color-green">
          <el-button icon="el-icon-plus" size='mini' type="text" @click="tableAdd('colors')">Add</el-button>
        </div>
      </div>
      <div class="box">
        <div class="title"><span class="star">*</span>尺码 Size</div>
        <div class="size-list">
          <el-checkbox-group v-model="checkSizes" @change="changeCheckSize()">
            <template v-for="item in sizeAttr.eur_size">
              <el-checkbox :key="item.specId" :label="item.specId">{{ item.value }}</el-checkbox>
            </template>
          </el-checkbox-group>
        </div>
      </div>
      <div v-if="checkSizes.length" class="box">
        <div class="title"><span class="star">*</span>尺码表 Size Chart</div>
        <el-button v-if="!businessId" icon="el-icon-plus" size='mini' @click="addSizeChart">Add Size Chart</el-button>
        <div v-else class="size-chart f-b-c">
          <div><i class="el-icon-success color-green"></i> 已添加</div>
          <div>
            <el-button type="text" size='mini' @click="addSizeChart">编辑</el-button>
            <el-button type="text" size='mini' @click="businessId = ''">删除</el-button>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="title"><span class="star">*</span>商品素材图 Commodity material map</div>
        <div class="img">
          <img :src="create.materialImgUrl" alt="">
        </div>
      </div>
      <div class="box">
        <div class="title"><span class="star">*</span>商品包装信息 Commodity packaging information</div>
        <div class="packaging">
          <div class="box">
            <div class="title">外包装图片 Outer packing picture</div>
            <div class="img-list f--c">
              <div v-for="(item, i) in create.productOuterPackageImageReqs" :key="item.imageUrl" class="img-item">
                <oss-img :src="item.imageUrl" :width="56" :height="56" />
                <div class="icon-x f-c-c pointer" style="top:0" @click="tableDelete(create.productOuterPackageImageReqs, i, 'noTable')">
                  <i class="el-icon-close"></i>
                </div>
              </div>
              <el-upload v-if="create.productOuterPackageImageReqs.length < 3" list-type="picture-card" class="upload-demo f--c"  action="" :multiple="false" accept="image/*" :before-upload="file => beforeUpload(file, create.productOuterPackageImageReqs, 'imageUrl')">
                <div>上传</div>
              </el-upload>
            </div>
          </div>
          <div class="box">
            <div class="title">外包装类型 Outer packing type</div>
            <el-radio-group v-model="create.productOuterPackageReq.packageType" size="small">
              <el-radio :label="0" border>硬包装</el-radio>
              <el-radio :label="1" border>软包装 + 硬物</el-radio>
              <el-radio :label="2" border>软包装 + 软物</el-radio>
            </el-radio-group>
          </div>
          <div class="box">
            <div class="title">外包装形状 Outer package shape</div>
            <el-radio-group v-model="create.productOuterPackageReq.packageShape" size="small">
              <el-radio :label="1" border>长方体</el-radio>
              <el-radio :label="2" border>圆柱体</el-radio>
              <el-radio :label="0" border>其他不规则形状</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div v-if="skuList.length" class="box">
        <div class="title"><span class="star">*</span>SKU信息 SKU Info</div>
        <el-table :data="skuList" border class="sku-list" style="width: 100%">
          <el-table-column width="120" fixed>
            <template slot="header">
              <div class="title"><span class="star">*</span>颜色 Color</div>
            </template>
            <div slot-scope="{row}">
              {{ row.sku_color.specName || '(未选择)' }}
            </div>
          </el-table-column>
          <el-table-column width="120">
            <template slot="header">
              <div class="title"><span class="star">*</span>尺码 Size</div>
            </template>
            <div slot-scope="{row}">
              {{ row.sku_size.specName }}
            </div>
          </el-table-column>
          <el-table-column min-width="120">
            <template slot="header">
              <div class="title"><span class="star">*</span>敏感属性</div>
            </template>
            <div>No</div>
          </el-table-column>
          <el-table-column min-width="460">
            <template slot="header">
              <div class="title"><span class="star">*</span>
                体积 Volume<el-button slot="reference" size='mini' type="text" @click="showDialogBatch('volume')">批量</el-button>
              </div>
            </template>
            <div slot-scope="{row}" class="f--c">
              <el-input placeholder="Input" v-model="row.productSkuWhExtAttrReq.productSkuVolumeReq.len" size='mini' style="margin-right:10px"  @input="e => handleInput(e, row.productSkuWhExtAttrReq.productSkuVolumeReq, 'len')" @blur="handleBlur(row.productSkuWhExtAttrReq.productSkuVolumeReq, 'len', row.productSkuWhExtAttrReq.productSkuVolumeReq.len, 1)">
                <template slot="prepend">长</template>
                <template slot="append">cm</template>
              </el-input>
              <el-input placeholder="Input" v-model="row.productSkuWhExtAttrReq.productSkuVolumeReq.width" size='mini' style="margin-right:10px" @input="e => handleInput(e, row.productSkuWhExtAttrReq.productSkuVolumeReq, 'width')" @blur="handleBlur(row.productSkuWhExtAttrReq.productSkuVolumeReq, 'width', row.productSkuWhExtAttrReq.productSkuVolumeReq.width, 1)">
                <template slot="prepend">宽</template>
                <template slot="append">cm</template>
              </el-input>
              <el-input placeholder="Input" v-model="row.productSkuWhExtAttrReq.productSkuVolumeReq.height" size='mini' style="margin-right:10px" @input="e => handleInput(e, row.productSkuWhExtAttrReq.productSkuVolumeReq, 'height')" @blur="handleBlur(row.productSkuWhExtAttrReq.productSkuVolumeReq, 'height', row.productSkuWhExtAttrReq.productSkuVolumeReq.height, 1)">
                <template slot="prepend">高</template>
                <template slot="append">cm</template>
              </el-input>
            </div>
          </el-table-column>
          <el-table-column min-width="180">
            <template slot="header">
              <div class="title"><span class="star">*</span>
                重量 Weight <el-button slot="reference" size='mini' type="text" @click="showDialogBatch('weight')">批量</el-button>
              </div>
            </template>
            <div slot-scope="{row}">
              <el-input placeholder="Input" v-model="row.productSkuWhExtAttrReq.productSkuWeightReq.value" size='mini' @input="e => handleInput(e, row.productSkuWhExtAttrReq.productSkuWeightReq, 'value')" @blur="handleBlur(row.productSkuWhExtAttrReq.productSkuWeightReq, 'value', row.productSkuWhExtAttrReq.productSkuWeightReq.value, 1)">
                <template slot="append">g</template>
              </el-input>
            </div>
          </el-table-column>
          <el-table-column min-width="300">
            <template slot="header">
              <div class="title"><span class="star">*</span>
                申报价格 Declaration price <el-button slot="reference" size='mini' type="text" @click="showDialogBatch('price')">批量</el-button>
              </div>
            </template>
            <div slot-scope="{row}">
              <el-input placeholder="Please Input" v-model="row.supplierPrice" size='mini' @input="e => handleInput(e, row, 'supplierPrice')" @blur="handleBlur(row, 'supplierPrice', row.supplierPrice, 2)">
                <template slot="prepend">{{ create.currency }}</template>
              </el-input>
            </div>
          </el-table-column>
          <el-table-column min-width="280">
            <template slot="header">
              <div class="title">SKU货号 SKU article number</div>
            </template>
            <div slot-scope="{row}">
              <el-input placeholder="Please Input" v-model="row.extCode" maxlength="22" show-word-limit size='mini'></el-input>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <footer class="f-c-c" v-if="$route.query.listingStatus != 1">
      <el-button type="primary" :disabled="!skuList.length" @click="listNow">List Now</el-button>
    </footer>

    <el-dialog
      v-if="checkSizes.length"
      title="Add Size Chart"
      :visible.sync="dialogVisible"
      width="680px">
      <div>
        <temu-create-template
          ref="temuCreateTemplate"
          templateType="addSizeChart"
          :elementList="allSizeChart.sizeSpecMeta && allSizeChart.sizeSpecMeta.elementList"
          :storeId="create.storeId"
          :catId="create.catId"
          :checkSizeList="checkSizeList"
          :isShow="dialogVisible"
          @createSizeChart="createSizeChart">
        </temu-create-template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="chartConfirm">Confirm</el-button>
      </span>
    </el-dialog>
    <temu-add-size-chart
      v-if="checkSizes.length"
      ref="temuAddSizeChart"
      :storeId="create.storeId"
      :catId="create.catId"
      :classId="sizeClassCat.classId"
      :className="sizeClassCat.className"
      :elementList="allSizeChart.sizeSpecMeta && allSizeChart.sizeSpecMeta.elementList"
      :groupList="allSizeChart.sizeSpecMeta && allSizeChart.sizeSpecMeta.groupList"
      :sizeAttr="sizeAttr"
      :checkSizeList="checkSizeList"
      @temuCreateSizeCharts="temuCreateSizeCharts"
    ></temu-add-size-chart>

    <el-dialog
      :title="dialogBatch.title"
      :visible.sync="dialogBatch.visible"
      width="500px">
      <div class="batch-set f">
        <div class="left">统一改为</div>
        <div v-if="dialogBatch.type === 'volume'" class="right">
          <el-input placeholder="Please Input" v-model="dialogBatch.len" size='mini' @input="e => handleInput(e, dialogBatch, 'len')" @blur="handleBlur(dialogBatch, 'len', dialogBatch.len, 1)">
            <template slot="prepend">长</template>
            <template slot="append">cm</template>
          </el-input>
          <el-input placeholder="Please Input" v-model="dialogBatch.width" size='mini' @input="e => handleInput(e, dialogBatch, 'width')" @blur="handleBlur(dialogBatch, 'width', dialogBatch.width, 1)">
            <template slot="prepend">宽</template>
            <template slot="append">cm</template>
          </el-input>
          <el-input placeholder="Please Input" v-model="dialogBatch.height" size='mini' @input="e => handleInput(e, dialogBatch, 'height')" @blur="handleBlur(dialogBatch, 'height', dialogBatch.height, 1)">
            <template slot="prepend">高</template>
            <template slot="append">cm</template>
          </el-input>
        </div>
        <div v-if="dialogBatch.type === 'weight'" class="right">
          <el-input placeholder="Please Input" v-model="dialogBatch.value" size='mini' @input="e => handleInput(e, dialogBatch, 'value')" @blur="handleBlur(dialogBatch, 'value', dialogBatch.value, 1)">
            <template slot="append">g</template>
          </el-input>
        </div>
        <div v-if="dialogBatch.type === 'price'" class="right">
          <el-input placeholder="Please Input" v-model="dialogBatch.supplierPrice" size='mini' @input="e => handleInput(e, dialogBatch, 'supplierPrice')" @blur="handleBlur(dialogBatch, 'supplierPrice', dialogBatch.supplierPrice, 2)">
            <template slot="prepend">{{ create.currency }}</template>
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBatch.visible = false">取消</el-button>
        <el-button type="primary" @click="handleBatch">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TemuAddSizeChart from './components/temuAddSizeChart.vue'
import temuCreateTemplate from './components/temuCreateTemplate.vue'
import API from '@/api'
import _ from 'lodash'
export default {
  components: { temuCreateTemplate, TemuAddSizeChart },
  data() {
    return {
      isEdit: false,
      create: {
        storeId: '',
        catId: '',
        productName: '',
        spuCode: '',
        currency: '',
        productWhExtAttrReq: {
          outerGoodsUrl: '',
          productOrigin: {
            countryShortName: 'CN'
          }
        },
        materialImgUrl: '', // 素材图
        productOuterPackageImageReqs: [
          { imageUrl: 'https://img.kakaclo.com/web-img/home/packaging.png' }
        ], // 外包装图片
        productOuterPackageReq: {
          packageShape: 0, // 外包装形状 0:不规则形状1:长方体2:圆柱体
          packageType: 2 // 外包装类型 0:硬包装 1:软包装+硬物 2:软包装+软物
        }
      },
      spuData: {}, // spu数据
      // 所有尺码表元素列表
      allSizeChart: {},
      storeList: [],
      commodityOrigins: [{
        value: 'CN',
        label: '中国'
      }],
      Languages: [
        { name: 'English', label: 'CN', disabled: true }
      ],
      checkLanguage: ['CN'],
      categoriesList: [],
      sizeClassCat: {},
      // 所有属性列表
      attrAll: [],
      tableAttr: [], // 表格类型属性
      enumAttr: [], // 枚举类型属性
      sizeAttr: {}, // 尺码属性
      colorAttr: {}, // 颜色属性
      checkSizes: [], // 选择的尺码 vid 列表
      checkSizeList: [], // 选择的尺码列表

      dialogBatch: {
        visible: false,
        len: '',
        width: '',
        height: '',
        value: '',
        supplierPrice: ''
      },

      // 尺码表id
      businessId: '',
      colors: [{
        colour_value: '',
        previewImgUrls: [
          // {
          //   src: 'https://img-kakaclo-url.oss-accelerate.aliyuncs.com/images/common/temu/nosave/ee11fdbc-b145-4e4e-a115-6cbccb20bc08.png?x-oss-process=image/resize,w_112,h_112,m_fill/format,webp',
          //   index: 0
          // }
        ],
        extCode: ''
      }],

      skuList: [],
      dialogVisible: false
    }
  },
  watch: {
    colors: {
      deep: true,
      handler: function(colors) {
        if (colors.length && colors[0].previewImgUrls.length) {
          this.$set(this.create, 'materialImgUrl', colors[0].previewImgUrls[0].src)
        }
      }
    }
  },
  created() {
    this.isEdit = !!this.$route.query.isEdit
    this.getStoreSelect()
  },
  methods: {
    addSizeChart() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.temuCreateTemplate.temuGetSizeCharts(this.businessId, 'edit')
      })
    },
    createSizeChart() {
      this.$refs.temuAddSizeChart.show()
    },

    temuListingDetail() {
      let param = {
        id: this.$route.query.id,
        listingStatus: this.$route.query.listingStatus,
        languageId: 1
      }
      API.temuListingDetail(param).then(res => {
        let data = res.data
        this.create = data
        this.spuData = data
        this.temuGetCategories()
        this.temuGetAttrs()
        this.temuGetSizeChartClass()
      })
    },

    // 获取用户店铺
    getStoreSelect() {
      API.getStoreSelect({
        platformCode: 'PD',
        userId: this.$store.state.common.userId
      }).then(res => {
        this.storeList = res.data
        if (this.isEdit) {
          this.temuListingDetail()
        }
      })
    },

    // 获取店铺设置信息
    async getShopSetInformation() {
      let { data } = await API.getShopSetInformation({ storeId: this.create.storeId })
      if (data) {
        this.create.currency = data.currency // 平台币种
      }
    },

    // 获取分类列表
    temuGetCategories() {
      this.create.storeName = this.storeList.find(t => t.storeId === this.create.storeId).storeName
      API.temuGetCategories({ storeId: this.create.storeId }).then(res => {
        const formatList = (list) => {
          list.forEach(e => {
            if (e.children && e.children.length) {
              formatList(e.children)
            } else {
              e.children = null
            }
          })
        }
        formatList(res.data.list)
        this.categoriesList = res.data.list
        this.getShopSetInformation()
      })
    },

    // 切换分类
    categorysChange(catId) {
      let obj = { ...this.create, catId }
      obj.cat1Id = 27011 // 固定一级为服装类目
      this.$refs.cascaderCat.getCheckedNodes()[0].path.forEach((t, i) => {
        obj[`cat${i + 2}Id`] = t
      })
      this.$set(this.$data, 'create', obj)
      this.temuGetAttrs()
      this.temuGetSizeChartClass()
    },

    // 获取分类id
    temuGetSizeChartClass() {
      API.temuGetSizeChartClass({ catId: this.create.catId, storeId: this.create.storeId }).then(res => {
        this.sizeClassCat = res.data.sizeSpecClassCat
        this.temuGetSizeChartsMeta()
      })
    },

    // // 查询尺码表模版规则(尺码表步骤2),获取全部信息
    // temuGetSizeChartSetting() {
    //   API.temuGetSizeChartSetting({ catId: this.create.catId, storeId: this.create.storeId }).then(res => {
    //     console.log('--', res)
    //   })
    // },
    // 查询尺码表元信息(尺码表步骤3),获取全部详细信息
    temuGetSizeChartsMeta() {
      API.temuGetSizeChartsMeta({ catId: this.create.catId, storeId: this.create.storeId, classId: this.sizeClassCat.classId }).then(res => {
        this.allSizeChart = res.data

        if (this.isEdit) {
          this.handleFormattingSpu()
        }
      })
    },

    // temu刊登spu加载
    temuGetLoadSpu() {
      API.temuGetLoadSpu({
        storeId: this.create.storeId,
        catId: this.create.catId,
        spuCode: this.create.spuCode
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.spuData = res.data
        this.create.productName = res.data.productName

        this.handleFormattingSpu()
      })
    },

    // 根据spu 带出对应值
    handleFormattingSpu() {
      // 格式化属性
      if (this.enumAttr.length && this.spuData.productPropertyReqs) {
        let values = this.tableAttr[0].values
        let tableAttr = this.spuData.productPropertyReqs.some(t => t.propName === '成分') ? [] : this.tableAttr
        this.spuData.productPropertyReqs.forEach(item => {
          if (item.propName === '成分') {
            tableAttr.push({ ...item, values })
          }
          this.enumAttr.forEach(item2 => {
            if (item.pid === item2.pid) {
              item2.vid = item.vid
              item2.propValue = item.propValue
            }
          })
        })
        this.tableAttr = tableAttr
      }
      // 格式化尺码
      if (this.sizeAttr.eur_size && this.spuData.productSpecPropertyReqs) {
        this.checkSizes = this.spuData.productSpecPropertyReqs.filter(t => t.parentSpecName === '尺码').map(item => item.specId)
        this.changeCheckSize(this.spuData.productSkcReqs)
      }
      // 格式化颜色
      if (this.colorAttr.values && this.spuData.productSkcReqs) {
        let colors = []
        this.spuData.productSkcReqs.forEach(item => {
          colors.push({
            colour_value: item.mainProductSkuSpecReqs[0].specId,
            previewImgUrls: item.previewImgUrls.map((t, i) => ({
              src: t,
              index: i
            })),
            extCode: item.extCode,
            colour_label: item.mainProductSkuSpecReqs[0].specName || '',
            color_attr: {
              group: {
                id: item.mainProductSkuSpecReqs[0].valueGroupId || '',
                name: item.mainProductSkuSpecReqs[0].valueGroupName || ''
              },
              vid: item.mainProductSkuSpecReqs[0].vid || '',
              extendInfo: item.mainProductSkuSpecReqs[0].valueExtendInfo || ''
            }
          })
        })
        this.colors = colors
      }
      // 带出尺码表
      if (this.spuData.sizeTemplateIds) {
        this.businessId = this.spuData.sizeTemplateIds.length ? this.spuData.sizeTemplateIds[0] : ''
      }
    },

    // 输入框只允许输入数字与一个小数点
    handleInput(e, row, key) {
      if (!+e && +e !== 0) {
        this.$set(row, key, e.replace(/[^\d]/g, '').replace(/^0{1,}/g, ''))
      }
    },

    // 输入框失去焦点，不能小于或等于0, isToFixed 保留小数点位数
    handleBlur(row, key, val, isToFixed) {
      if (isToFixed) this.$set(row, key, (+val).toFixed(isToFixed))
      if (+val <= 0) this.$set(row, key, 1)
      if ((key === 'len' || key === 'width' || key === 'height') && val > 299.9) {
        this.$message.warning('长宽高属性限制为1~299.9cm')
        this.$set(row, key, 299.9)
      }
      if ((key === 'value') && (val > 99999 || val < 2)) {
        this.$message.warning('重量属性限制为2~99999g')
        if (val > 99999) {
          this.$set(row, key, 99999)
        }
        if (val < 2) {
          this.$set(row, key, 2)
        }
      }
      if ((key === 'supplierPrice') && val > 99999) {
        this.$message.warning('申报价格限制为1~99999')
        this.$set(row, key, 99999)
      }
    },

    // // 查询色块图
    // temuGetColorImageUrl() {
    //   API.temuGetColorImageUrl().then(res => {
    //     console.log(res)
    //   })
    // },

    // 全部属性
    temuGetAttrs() {
      API.temuGetAttrs({ catId: this.create.catId, storeId: this.create.storeId }).then(res => {
        this.attrAll = res.data.list
        const reqParams = this.attrAll.map(t => ({
          pid: t.pid,
          propName: t.name,
          propValue: '',
          refPid: t.refPid,
          templatePid: t.templatePid,
          valueUnit: t.valueUnit,
          vid: '',
          numberInputValue: '',
          controlType: t.controlType,
          values: t.values,
          required: t.required,
          propertyChooseTitle: t.propertyChooseTitle,
          numberInputTitle: t.numberInputTitle,
          parentSpecId: t.parentSpecId
        }))
        this.tableAttr = reqParams.filter(t => t.controlType === 16)
        this.enumAttr = reqParams.filter(t => t.controlType === 1 && t.propName !== '尺码' && t.propName !== '颜色')
        this.sizeAttr = reqParams.filter(t => t.propName === '尺码')[0]
        let colorAttr = reqParams.filter(t => t.propName === '颜色')[0]
        let arr = colorAttr.values.map(t => ({ ...t, colour_system: t.group }))
        let cascader = _.uniqBy(arr.map(t => t.colour_system), 'id')
        cascader.forEach(item => {
          item.children = []
          item.specName = item.name
          item.specId = item.id
          arr.forEach(t => {
            if (item.id === t.colour_system.id) item.children.push({ ...t, specName: t.value })
          })
        })
        colorAttr.cascader = cascader.map(item => ({ ...item, extendInfo: item.children[0].extendInfo }))
        this.colorAttr = colorAttr
        this.sizeAttr.eur_size = _.cloneDeep(this.sizeAttr.values.filter(t => !t.value.includes('Asian') && !t.value.includes('etite')))

        if (this.enumAttr.some(t => t.propName === '护理说明')) {
          let index = this.enumAttr.findIndex(t => t.propName === '护理说明')
          if (index > -1) {
            let i = this.enumAttr[index].values.findIndex(t => t.value === '手洗')
            if (i > -1) {
              this.$set(this.enumAttr[index], 'vid', this.enumAttr[index].values[i].vid)
              this.changeAttr(this.enumAttr[index])
            }
          }
        }

        this.handleFormattingSpu()
      })
    },
    // 切换属性
    changeAttr(row) {
      row.values.forEach(item => {
        if (row.vid === item.vid) {
          row.propValue = item.value
        }
      })
    },
    // 表格删除
    tableDelete(arr, i, noTable) {
      arr.splice(i, 1)
      if (noTable === 'carousel') {
        arr.forEach((t, i1) => this.$set(t, 'index', i1))
      }
      if (!noTable) {
        this.handleSkuList('delete', i)
      }
    },
    // 图片删除
    imgDelete(data, key) {
      this.$set(data, key, '')
    },
    // 表格添加
    tableAdd(table) {
      if (table === 'tableAttr') {
        let obj = { ...this.tableAttr[0] }
        obj.propValue = ''
        obj.vid = ''
        obj.numberInputValue = ''
        this.tableAttr.push(obj)
      } else if (table === 'colors') {
        let obj = {
          colour_value: '',
          previewImgUrls: [],
          extCode: ''
        }
        this.colors.push(obj)
        this.handleSkuList('push')
      }
    },
    // 切换色值
    changeColor(id, row, index) {
      this.colorAttr.values.forEach(t => {
        if (t.specId === id) {
          this.$set(row, 'colour_label', t.value)
          this.$set(row, 'color_attr', t)
        }
      })
      if (this.skuList.length) {
        let sizeLen = this.checkSizeList.length
        this.skuList.forEach((item, i) => {
          if (i >= (index * sizeLen) && (i < (index + 1) * sizeLen)) {
            this.$set(item.sku_color, 'specId', row.colour_value)
            this.$set(item.sku_color, 'specName', row.colour_label)
            // item.productSkuWhExtAttrReq = {
            //   productSkuSensitiveAttrReq: {
            //     isSensitive: 0
            //   },
            //   productSkuVolumeReq: {
            //     len: '',
            //     width: '',
            //     height: ''
            //   },
            //   productSkuWeightReq: {
            //     value: ''
            //   }
            // }
            // item.supplierPrice = ''
            // item.extCode = ''
          }
        })
      }
    },
    // 切换尺码
    changeCheckSize(skcData) {
      this.businessId = ''
      let checkSizeList = this.sizeAttr.eur_size.filter(t => this.checkSizes.includes(t.specId))
      this.checkSizeList = checkSizeList
      if (skcData) this.handleSkuList('init', '', skcData)
      else this.handleSkuList()
    },

    // 格式化 sku列表
    handleSkuList(type, del_idx, skcData) {
      let checkSizeList = this.checkSizeList
      let colors = this.colors
      let skuList = []
      if (type === 'init') {
        skcData.forEach(item => {
          item.productSkuReqs.forEach(item2 => {
            let obj = {
              currencyType: item2.currencyType,
              extCode: item2.extCode,
              supplierPrice: item2.supplierPrice || '',
              productSkuWhExtAttrReq: item2.productSkuWhExtAttrReq,
              sku_color: item2.productSkuSpecReqs.filter(t => t.parentSpecName === '颜色')[0],
              sku_size: item2.productSkuSpecReqs.filter(t => t.parentSpecName === '尺码')[0],
              thumbUrl: item2.thumbUrl
            }
            skuList.push(obj)
          })
        })
        this.skuList = skuList
        return
      }
      if (type === 'delete') {
        skuList = this.skuList
        let sizeLen = this.checkSizeList.length
        skuList.splice(del_idx * sizeLen, sizeLen)
        this.skuList = skuList
        return
      }
      if (type === 'push') {
        skuList = this.skuList
      }
      colors.forEach((item, index) => {
        if (type !== 'push' || (type === 'push' && index === colors.length - 1)) {
          checkSizeList.forEach(item2 => {
            skuList.push({
              sku_color: {
                parentSpecId: this.colorAttr.parentSpecId,
                parentSpecName: this.colorAttr.propName,
                specId: item.colour_value,
                specName: item.colour_label
              },
              sku_size: {
                parentSpecId: this.sizeAttr.parentSpecId,
                parentSpecName: this.sizeAttr.propName,
                specId: item2.specId,
                specName: item2.value
              },
              productSkuWhExtAttrReq: {
                productSkuSensitiveAttrReq: {
                  isSensitive: 0
                },
                productSkuVolumeReq: {
                  len: '',
                  width: '',
                  height: ''
                },
                productSkuWeightReq: {
                  value: ''
                }
              },
              supplierPrice: '',
              extCode: '',
              currencyType: this.create.currency
            })
          })
        }
      })
      this.skuList = skuList
    },

    // 创建表格确认
    chartConfirm() {
      let list = this.$refs.temuCreateTemplate.sizeList
      list.forEach(t => {
        for (let k in t) {
          if (!this.$refs.temuCreateTemplate.checkSize.includes(+k) && +k !== 1) delete t[k]
        }
      })
      let data = {
        storeId: this.create.storeId,
        catId: this.create.catId,
        classId: this.sizeClassCat.classId,
        className: this.sizeClassCat.className,
        name: '',
        reusable: false,
        content: {
          meta: {
            elementList: this.allSizeChart.sizeSpecMeta.elementList.filter(t => this.$refs.temuCreateTemplate.checkSize.includes(t.id)).map(t => ({ id: t.id, name: t.name })),
            groupList: this.allSizeChart.sizeSpecMeta.groupList.map(t => ({ id: t.id, name: t.name }))
          },
          records: list.map(t => ({ values: t }))
        }
      }
      this.temuCreateSizeCharts(data, 'addSizeChart')
    },

    // 创建尺码表 （reusable：true尺码表模板，false当前商品尺码表）
    temuCreateSizeCharts(data, type) {
      if (type === 'temuTemplate' && !data.name) {
        return this.$message.error('请输入模板名称')
      }
      if (type === 'temuTemplate' && !data.content.records.length) {
        return this.$message.error('请勾选尺码')
      }
      let list = data.content.records
      let isEmpty = false
      list.forEach(t => {
        for (let k in t.values) {
          if (!t.values[k] && !t.values[k] !== 0) isEmpty = true
        }
      })
      if (isEmpty) {
        return this.$message.error('请填写完整勾选的表格信息')
      }
      if (type === 'temuTemplate') {
        this.$refs.temuAddSizeChart.loading = true
      }
      API.temuCreateSizeCharts(data).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        if (type === 'temuTemplate') {
          this.$refs.temuAddSizeChart.dialogVisible = false
          this.$refs.temuAddSizeChart.loading = false
          this.$refs.temuCreateTemplate.temuGetSizeCharts(res.data.businessId, 'add')
        } else {
          this.dialogVisible = false
          this.businessId = res.data.businessId
        }
      })
    },

    // 上传
    beforeUpload(file, row, key) {
      API.customProductGetSignValue({ directory: 'common/temu/nosave/' }).then(res => {
        let signValue = res.data
        let data = new FormData()
        data.append('directory', 'common/temu/nosave/')
        data.append('signValue', signValue)
        data.append('fileList', file)
        API.orderUploadFile(data).then(res => {
          if (key === 'colors') {
            let arr = row.previewImgUrls
            arr.push({
              src: res.data,
              index: row.previewImgUrls.length
            })
            this.$set(row, 'previewImgUrls', arr)
          } else if (key === 'imageUrl') {
            row.push({
              imageUrl: res.data
            })
          } else this.$set(row, key, res.data)
          this.$forceUpdate()
        })
      })
      return false
    },

    // 更改排序
    handleSortImg(e, row, i) {
      let arr = row.previewImgUrls
      let obj = arr[i]
      arr.splice(i, 1)
      arr.splice(e, 0, obj)
      arr.forEach((t, i) => {
        t.index = i
      })
    },

    // 显示批量弹窗
    showDialogBatch(type) {
      this.dialogBatch.visible = true
      this.dialogBatch.type = type
      this.dialogBatch.title = type === 'volume' ? '批量修改体积' : type === 'weight' ? '批量修改重量' : type === 'price' ? '批量修改申报价格' : ''
    },
    // 批量设置
    handleBatch() {
      this.skuList.forEach(item => {
        if (this.dialogBatch.type === 'volume') {
          this.$set(item.productSkuWhExtAttrReq.productSkuVolumeReq, 'len', this.dialogBatch.len)
          this.$set(item.productSkuWhExtAttrReq.productSkuVolumeReq, 'width', this.dialogBatch.width)
          this.$set(item.productSkuWhExtAttrReq.productSkuVolumeReq, 'height', this.dialogBatch.height)
        } else if (this.dialogBatch.type === 'weight') {
          this.$set(item.productSkuWhExtAttrReq.productSkuWeightReq, 'value', this.dialogBatch.value)
        } else if (this.dialogBatch.type === 'price') {
          this.$set(item, 'supplierPrice', this.dialogBatch.supplierPrice)
        }
      })
      this.dialogBatch.visible = false
    },

    listNow(filterDuplicateSpu = false) {
      let create = _.cloneDeep(this.create)
      if (filterDuplicateSpu) create.filterDuplicateSpu = false
      if (!this.create.productName) {
        this.$message.error('请输入产品名称')
        return
      }
      let productPropertyReqs = []
      if (this.tableAttr.some(t => !t.vid || !t.numberInputValue)) {
        return this.$message.error('请填写完整 "成分" 属性表格所有内容')
      }
      if (+_.sum(this.tableAttr.map(t => parseFloat(t.numberInputValue))) !== 100) {
        return this.$message.error('"成分" 属性表格中 "成分比例"之和必须为100%')
      }
      productPropertyReqs = this.tableAttr.map(t => ({
        pid: t.pid,
        propName: t.propName,
        propValue: t.propValue,
        refPid: t.refPid,
        templatePid: t.templatePid,
        valueUnit: t.valueUnit[0],
        vid: t.vid,
        numberInputValue: t.numberInputValue
      }))
      _.forEach(this.enumAttr, (t) => {
        if (t.required && !t.vid) {
          this.$message.error(`请选择 "${t.propName}" 属性`)
          return false
        }
        t.vid && productPropertyReqs.push({
          pid: t.pid,
          propName: t.propName,
          propValue: t.propValue,
          refPid: t.refPid,
          templatePid: t.templatePid,
          valueUnit: t.valueUnit[0],
          vid: t.vid,
          numberInputValue: null
        })
      })
      create.productPropertyReqs = productPropertyReqs
      if (this.enumAttr.some(t => t.required && !t.vid)) return
      if (this.colors.some(t => !t.colour_value || t.previewImgUrls.length < 5)) {
        return this.$message.error(`"颜色" 属性表格中，色值不能为空，每列轮播图数量为5-10张`)
      }
      if (!this.checkSizes.length) {
        return this.$message.error(`请至少选择一个 "尺码" 属性`)
      }
      // 颜色
      let productSpecPropertyReqs = this.colors.map(t => ({
        parentSpecId: this.colorAttr.parentSpecId,
        parentSpecName: this.colorAttr.propName,
        specId: t.colour_value,
        specName: t.colour_label,
        refPid: this.colorAttr.refPid,
        pid: this.colorAttr.pid,
        templatePid: this.colorAttr.templatePid,
        propName: t.colour_label,
        vid: t.color_attr.vid,
        propValue: this.colorAttr.propName,
        valueUnit: this.colorAttr.valueUnit[0],
        valueGroupId: t.color_attr.group.id,
        valueGroupName: t.color_attr.group.name,
        valueExtendInfo: t.color_attr.extendInfo
      }))
      // 尺码
      this.checkSizeList.forEach(t => {
        let obj = {
          parentSpecId: this.sizeAttr.parentSpecId,
          parentSpecName: this.sizeAttr.propName,
          specId: t.specId,
          specName: t.value,
          refPid: this.sizeAttr.refPid,
          pid: this.sizeAttr.pid,
          templatePid: this.sizeAttr.templatePid,
          propName: this.sizeAttr.propName,
          vid: t.vid,
          propValue: t.value,
          valueUnit: this.sizeAttr.valueUnit[0],
          valueGroupId: t.group.id,
          valueGroupName: t.group.name,
          valueExtendInfo: ''
        }
        productSpecPropertyReqs.push(obj)
      })
      create.productSpecPropertyReqs = productSpecPropertyReqs
      if (this.skuList.some(t => !t.productSkuWhExtAttrReq.productSkuVolumeReq.len || !t.productSkuWhExtAttrReq.productSkuVolumeReq.width || !t.productSkuWhExtAttrReq.productSkuVolumeReq.height || !t.productSkuWhExtAttrReq.productSkuWeightReq.value || !t.supplierPrice)) {
        return this.$message.error(`请填写完整 "SKU信息" 表格所有必填项`)
      }

      let productSkcReqs = []
      let total_img = 0
      this.colors.forEach(item => {
        let productSkuReqs = []
        this.skuList.forEach(item2 => {
          if (item.colour_value === item2.sku_color.specId) {
            let obj2 = {
              thumbUrl: item.previewImgUrls[0].src,
              extCode: item2.extCode,
              supplierPrice: item2.supplierPrice,
              currencyType: item2.currencyType,
              productSkuSpecReqs: [item2.sku_color, item2.sku_size],
              productSkuWhExtAttrReq: item2.productSkuWhExtAttrReq
            }
            productSkuReqs.push(obj2)
          }
        })

        let obj = {
          previewImgUrls: item.previewImgUrls.map(t => t.src),
          extCode: item.extCode,
          mainProductSkuSpecReqs: [{
            parentSpecId: this.colorAttr.parentSpecId,
            parentSpecName: this.colorAttr.propName,
            specId: item.colour_value,
            specName: item.colour_label
          }],
          productSkuReqs,
          colorImageUrl: item.color_attr.extendInfo
        }
        productSkcReqs.push(obj)
        total_img += item.previewImgUrls.length
      })
      create.productSkcReqs = productSkcReqs

      // 格式化轮播图
      let carouselImageUrls = []
      total_img = total_img > 10 ? 10 : total_img
      let color_len = this.colors.length
      let j = 0 // 行
      let k = 0 // 列
      for (let i = 0; i < total_img; i++) {
        if (j === color_len - 1) {
          j = 0
          k++
        } else j++
        if (this.colors[j].previewImgUrls.length - 1 >= k) {
          carouselImageUrls.push(this.colors[j].previewImgUrls[k].src)
        }
      }
      create.carouselImageUrls = carouselImageUrls

      // 尺码表
      if (!this.businessId) return this.$message.error(`请添加尺码表`)
      create.sizeTemplateIds = [this.businessId]
      create.showSizeTemplateIds = [this.businessId]
      if (!create.productOuterPackageImageReqs.length) return this.$message.error(`外包装图片数量为1-3张`)

      for (let i = 1; i < 11; i++) {
        if (!create[`cat${i}Id`]) create[`cat${i}Id`] = 0
      }
      create.synTypeList = create.productId ? [2] : [1]

      let apiUrl = this.isEdit ? 'temuListingEdit' : 'temuListingAdd'
      API[apiUrl](create).then(res => {
        if (res.code === 220011) {
          this.$confirm(res.message, {
            type: 'warning'
          }).then(() => {
            this.listNow(true)
          })
          return
        } else if (res.code !== 10000) return this.$message.error(res.message)
        this.$router.back()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.temu-create {
  .update-alert {
    background-color: #fdf6ec;
    width: calc(100vw - 214px);
    height: 36px;
    position: fixed;
    top: 40px;
    z-index: 9;
    left: 208px;
    padding: 20px;
    color: #FAB55A;

    i {
      font-size: 20px;
      color: #e6a23c;
    }
  }

  min-width: 1100px;
  padding-bottom: 90px;
  h1 {
    height: 28px;
    margin: 20px 0 16px 0;
    font-size: 20px;
    color: #303133;
    .left {
      width: 4px;
      height: 100%;
      margin-right: 8px;
    }
  }

  .head {
    width: 100%;
    height: 54px;
    background-color: #eff1f7;
    padding: 0 24px;
    margin-bottom: 16px;
    > div {
      margin-right: 24px;
      color: #303133;
      .title {
        color: #909399;
        padding-right: 6px;
      }
    }
  }

  .head-product {
    background-color: #fff;
    padding: 24px;
    margin-bottom: 16px;
    .left {
      width: 212px;
      height: 292px;
      margin-right: 16px;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .right {
      flex: 1;
      height: 292px;
      background-color: #f7f8fb;
      padding: 16px;
      font-size: 12px;
      color: #606266;
      .item {
        flex: 1;
        margin-bottom: 20px;
        .title {
          margin-bottom: 4px;
          .star {
            color: #F36D6F;
          }
        }
      }

    }
  }

  .content-box {
    padding: 24px;
    background-color: #fff;
    color: #606266;
    .box {
      flex: 1;
      margin-bottom: 20px;
      .title {
        margin-bottom: 8px;
        .star {
          color: #F36D6F;
        }
      }

      .attr-list {
        flex-wrap: wrap;
        .item {
          width: 32%;
          margin-bottom: 18px;
        }
      }

      .add {
        margin-top: 2px;
      }

      .img-list {
        margin-left: 10px;
        width: 100%;
        overflow-y: hidden;
        overflow-x: auto;
        .img-item {
          width: 56px;
          border-radius: 4px;
          margin-right: 8px;
          font-size: 12px;
          position: relative;

          .img-item-head {
            width: 100%;
            height: 20px;
            top: -24px;
            font-size: 11px;
            color: #909399;
          }

          img {
            width: 56px;
            height: 56px;
          }
          .icon-x {
            width: 14px;
            height: 14px;
            position: absolute;
            top: 20px;
            right: 0;
            display: block;
            background-color: #606266;
            >i {
              display: block;
              line-height: 14px;
              font-size: 10px;
              margin-left: 2px;
              color: #fff;
            }
          }
          .foot {
            width: 100%;
            position: absolute;
            bottom: 0;
            font-size: 12px;
            border-top: 1px solid #aaa;
            background: rgba($color: #303133, $alpha: .7);
            div {
              flex: 1;
              display: flex;
              justify-content: center;
              color: #fff;
            }
          }
        }
      }

      .size-list {
        /deep/ .el-checkbox {
          margin-right: 30px;
          margin-bottom: 8px;
        }
        /deep/ .el-checkbox__label {
          width: 180px;
        }
      }

      .size-chart {
        width: 160px;
        height: 28px;
        border: 1px solid #DCDFE6;
        border-radius: 3px;
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 12px;
        /deep/ .el-button {
          font-size: 12px;
        }
      }

      .img {
        width: 56px;
        height: 56px;
        position: relative;
        >img {
          width: 100%;
          height: 100%;
        }
        .el-icon-error {
          position: absolute;
          top: 2px;
          right: 2px;
        }
      }

      .packaging {
        width: 100%;
        background-color: rgb(247, 248, 251);
        padding: 16px;
        box-sizing: border-box;

        /deep/ .el-radio.is-bordered{
          margin-left: 0;
          margin-right: 10px;
          width: 206px;
          background-color: #fff;
        }
      }

      .upload-demo {
        /deep/ .el-upload--picture-card{
          width: 56px;
          height: 56px;
          >div {
            line-height: 56px;
            width: 56px;
            height: 56px;
          }
        }
      }

      .sku-list {
        /deep/ .el-input-group__prepend{
          padding: 0 10px;
        }
        /deep/ .el-input-group__append{
          padding: 0 10px;
        }
      }

      table {
        .title {
          margin-bottom: 0;
        }
      }
    }
  }

  footer {
    position: fixed;
    z-index: 9;
    bottom: 0;
    left: 207px;
    height: 80px;
    width: calc(100vw - 208px);
    background-color: #fff;
    border-top: 1px solid #f5f7f7
  }

  /deep/ .el-input .el-input__inner {
    border-radius: 0;
  }
  /deep/ .el-input-group__append, .el-input-group__prepend {
    border-radius: 0;
  }

  /deep/ .el-dialog__body {
    padding: 16px 20px 0 20px;
  }

}
.img-sort {
  /deep/ .el-radio--mini{
    margin-right: 10px;
  }
}
.color-select {
  i {
    width: 16px;
    height: 16px;
    border: 1px solid #e8e8e8;
    margin-right: 8px;
    border-radius: 50%;
  }
}

.batch-set {
  padding: 0 20px;
  .left {
    flex-shrink: 0;
    margin-right: 10px;
    line-height: 26px;
  }
  .right {
    /deep/ .el-input {
      margin-bottom: 10px;
    }
  }
}
</style>
